module.exports = __webpack_public_path__ + "static/media/warning-small.40a8f1ac.svg";